/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Sections_Latestreleased1Inputs */

const id_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilis Terbaru`)
};

const ms_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluaran Terkini`)
};

const da_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senest Udgivet`)
};

const de_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste Veröffentlichungen`)
};

const en_us2_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Released`)
};

const es_es2_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos lanzamientos`)
};

const es_mx2_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos lanzamientos`)
};

const fil_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pinakabagong Release`)
};

const fr_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernières sorties`)
};

const it_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultime uscite`)
};

const hu_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legújabb megjelenések`)
};

const nl_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent uitgebracht`)
};

const no_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste utgivelser`)
};

const pl_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnowsze wydania`)
};

const pt_br2_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançamentos recentes`)
};

const pt_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançados recentemente`)
};

const ro_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansate recent`)
};

const fi_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisimmät julkaisut`)
};

const sv_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast släppta`)
};

const vi_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát hành mới nhất`)
};

const tr_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Çıkanlar`)
};

const cs_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnověji vydané`)
};

const bg_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-нови издания`)
};

const ru_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние релизы`)
};

const uk_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні релізи`)
};

const ar_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحدث الإصدارات`)
};

const hi_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम रिलीज़`)
};

const th_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่งวางจำหน่าย`)
};

const ja_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新リリース`)
};

const zh_cn2_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新发布`)
};

const zh_hant1_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新發布`)
};

const ko_home_sections_latestreleased1 = /** @type {(inputs: Home_Sections_Latestreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최신 출시`)
};

/**
* | output |
* | --- |
* | "Latest Released" |
*
* @param {Home_Sections_Latestreleased1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_sections_latestreleased1 = /** @type {((inputs?: Home_Sections_Latestreleased1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Sections_Latestreleased1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_sections_latestreleased1(inputs)
	if (locale === "ms") return ms_home_sections_latestreleased1(inputs)
	if (locale === "da") return da_home_sections_latestreleased1(inputs)
	if (locale === "de") return de_home_sections_latestreleased1(inputs)
	if (locale === "en-US") return en_us2_home_sections_latestreleased1(inputs)
	if (locale === "es-ES") return es_es2_home_sections_latestreleased1(inputs)
	if (locale === "es-MX") return es_mx2_home_sections_latestreleased1(inputs)
	if (locale === "fil") return fil_home_sections_latestreleased1(inputs)
	if (locale === "fr") return fr_home_sections_latestreleased1(inputs)
	if (locale === "it") return it_home_sections_latestreleased1(inputs)
	if (locale === "hu") return hu_home_sections_latestreleased1(inputs)
	if (locale === "nl") return nl_home_sections_latestreleased1(inputs)
	if (locale === "no") return no_home_sections_latestreleased1(inputs)
	if (locale === "pl") return pl_home_sections_latestreleased1(inputs)
	if (locale === "pt-BR") return pt_br2_home_sections_latestreleased1(inputs)
	if (locale === "pt") return pt_home_sections_latestreleased1(inputs)
	if (locale === "ro") return ro_home_sections_latestreleased1(inputs)
	if (locale === "fi") return fi_home_sections_latestreleased1(inputs)
	if (locale === "sv") return sv_home_sections_latestreleased1(inputs)
	if (locale === "vi") return vi_home_sections_latestreleased1(inputs)
	if (locale === "tr") return tr_home_sections_latestreleased1(inputs)
	if (locale === "cs") return cs_home_sections_latestreleased1(inputs)
	if (locale === "bg") return bg_home_sections_latestreleased1(inputs)
	if (locale === "ru") return ru_home_sections_latestreleased1(inputs)
	if (locale === "uk") return uk_home_sections_latestreleased1(inputs)
	if (locale === "ar") return ar_home_sections_latestreleased1(inputs)
	if (locale === "hi") return hi_home_sections_latestreleased1(inputs)
	if (locale === "th") return th_home_sections_latestreleased1(inputs)
	if (locale === "ja") return ja_home_sections_latestreleased1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_sections_latestreleased1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_sections_latestreleased1(inputs)
	return ko_home_sections_latestreleased1(inputs)
});
export { home_sections_latestreleased1 as "home.sections.latestReleased" }